<template>
    <v-container>
        <v-layout>
            <v-flex md12 v-if="!cargandoDatos">
                <v-card>
                    <v-card-text>
                        <table class="ui attached table">
                            <thead>
                                <tr>
                                    <th class="three wide">No. de Control</th>
                                    <th class="seven wide">Nombre del Estudiante</th>
                                    <th class="six wide">Plan de Estudios</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{alumno.noDeControl}}</td>
                                    <td>{{alumno.nombreCompleto}}</td>
                                    <td>{{kardex.planEstudios}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="ui attached table">
                            <thead>
                            <tr>
                                <th class="three wide">Semestre</th>
                                <th class="seven wide">Carrera</th>
                                <th class="six wide">Especialidad</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{alumno.semestre}}</td>
                                <td>{{alumno.carrera}}</td>
                                <td>{{kardex.especialidad}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                    <v-card-text>
                        <div v-for="item in kardex.periodosCursados" style="margin-top: calc(2rem -  0.14285714em )">
                            <h5 class="ui top attached block header">{{item.periodo}}</h5>
                            <table class="ui attached unstackable selectable table">
                                <thead>
                                    <tr>
                                        <th class="one wide">No.</th>
                                        <th class="two wide">Clave</th>
                                        <th class="five wide">Nombre Materia</th>
                                        <th>Créditos</th>
                                        <th>Calificación</th>
                                        <th>Evaluación</th>
                                        <th>Observaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(materia, index) in item.calificaciones">
                                        <td>{{index + 1}}</td>
                                        <td>{{materia.clave}}</td>
                                        <td>{{materia.nombre}}</td>
                                        <td>{{materia.creditos}}</td>
                                        <td>{{materia.calificacion}}</td>
                                        <td>{{materia.tipoEvaluacion}}</td>
                                        <td>
                                            <div v-if="materia.observaciones">
                                                <v-alert :value="true" outline color="error">
                                                    {{materia.observaciones.mensaje}}
                                                </v-alert>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="ui bottom attached table">
                                <thead>
                                    <tr>
                                        <th>
                                            <b>Promedio Semestral:</b>
                                            <span class="five wide" v-html="promedioSemestral(item.calificaciones)"></span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <b>Creditos Aprobados/Cursados:</b>
                                            <span class="five wide" v-html="creditosAprobados(item.calificaciones)"></span>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <table class="ui unstackable selectable table">
                            <thead>
                            <tr>
                                <th>Promedio Aritmético:</th>
                                <th>Créditos Aprobados:</th>
                                <th>Porcentaje de Avance:</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{promedioAritmetico}}</td>
                                    <td>{{totalCreditosAprobados}}</td>
                                    <td>{{porcentajeAvance}} %</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="250px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando Kardex</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
            <v-dialog v-model="generandoPdf" max-width="250px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Generando archivo PDF</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
            <v-btn
                color="red accent-4"
                fab
                dark
                bottom
                right
                fixed
                @click="imprimirKardex"
            >
                <v-icon>print</v-icon>
            </v-btn>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import fileSaver from 'file-saver'

  export default {
    name: 'KardexPage',
    data: () => ({
      cargandoDatos: false,
      generandoPdf: false,
      kardex: []
    }),
    computed: {
      ...mapState({
        alumno: state => state.user.profile
      }),
      promedioAritmetico: function () {
        let totalMaterias = 0
        let totalCalificaciones = 0
        const periodos = this.kardex.periodosCursados

        periodos.forEach(periodo => {
          periodo.calificaciones.forEach(materia => {
            if (!isNaN(parseInt(materia.calificacion)) && materia.clave !== 'ACOM' && materia.nombre !== 'TESIS') {
              totalMaterias++
              totalCalificaciones += parseInt(materia.calificacion)
            }
          })
        })

        return Math.round((totalCalificaciones / totalMaterias) * 100) / 100
      },
      totalCreditosAprobados: function () {
        let totalCreditos = 0
        const periodos = this.kardex.periodosCursados

        periodos.forEach(periodo => {
          periodo.calificaciones.forEach(materia => {
            if (!isNaN(parseInt(materia.calificacion))) {
              totalCreditos += parseInt(materia.creditos)
            }
          })
        })

        return totalCreditos
      },
      porcentajeAvance: function () {
        return Math.round((this.totalCreditosAprobados * 100) / this.kardex.totalCreditos)
      }
    },
    methods: {
      getKardex () {
        this.cargandoDatos = true
        axios.get('alumno/kardex')
          .then(request => {
            this.kardex = request.data
            this.cargandoDatos = false
          })
      },
      promedioSemestral (materias) {
        const length = materias.length
        let total = 0

        materias.forEach(function (item) {
          total += isNaN(parseInt(item.calificacion)) ? 0 : parseInt(item.calificacion)
        })

        return Math.round((total / length) * 100) / 100
      },
      creditosAprobados (materias) {
        let totalCreditos = 0
        let totalAprobados = 0

        materias.forEach(function (item) {
          totalCreditos += item.creditos
          totalAprobados += isNaN(parseInt(item.calificacion)) ? 0 : parseInt(item.creditos)
        })

        return totalAprobados + '/' + totalCreditos
      },
      imprimirKardex () {
        this.generandoPdf = true
        axios.get('alumno/kardex/download', {responseType: 'arraybuffer'})
          .then(response => {
            this.generandoPdf = false
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, 'kardex.pdf')
          })
      }
    },
    created () {
      this.getKardex()
    }
  }
</script>

<style scoped>
    .alert {
        font-size: 12px;
        padding: 5px;
    }

    table.table thead tr {
        height: auto;
    }
    table.table tbody td, table.table tbody th {
        height: auto;
    }

    /*!
     * # Semantic UI 2.3.2 - Header
     * http://github.com/semantic-org/semantic-ui/
     *
     *
     * Released under the MIT license
     * http://opensource.org/licenses/MIT
     *
     */


    /*******************************
                Header
    *******************************/


    /* Standard */
    .ui.header {
        border: none;
        margin: calc(2rem -  0.14285714em ) 0em 1rem;
        padding: 0em 0em;
        font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: bold;
        line-height: 1.28571429em;
        text-transform: none;
        color: rgba(0, 0, 0, 0.87);
    }
    .ui.header:first-child {
        margin-top: -0.14285714em;
    }
    .ui.header:last-child {
        margin-bottom: 0em;
    }

    /*--------------
       Sub Header
    ---------------*/

    .ui.header .sub.header {
        display: block;
        font-weight: normal;
        padding: 0em;
        margin: 0em;
        font-size: 1rem;
        line-height: 1.2em;
        color: rgba(0, 0, 0, 0.6);
    }

    /*--------------
          Icon
    ---------------*/

    .ui.header > .icon {
        display: table-cell;
        opacity: 1;
        font-size: 1.5em;
        padding-top: 0em;
        vertical-align: middle;
    }

    /* With Text Node */
    .ui.header .icon:only-child {
        display: inline-block;
        padding: 0em;
        margin-right: 0.75rem;
    }

    /*-------------------
            Image
    --------------------*/

    .ui.header > .image:not(.icon),
    .ui.header > img {
        display: inline-block;
        margin-top: 0.14285714em;
        width: 2.5em;
        height: auto;
        vertical-align: middle;
    }
    .ui.header > .image:not(.icon):only-child,
    .ui.header > img:only-child {
        margin-right: 0.75rem;
    }

    /*--------------
         Content
    ---------------*/

    .ui.header .content {
        display: inline-block;
        vertical-align: top;
    }

    /* After Image */
    .ui.header > img + .content,
    .ui.header > .image + .content {
        padding-left: 0.75rem;
        vertical-align: middle;
    }

    /* After Icon */
    .ui.header > .icon + .content {
        padding-left: 0.75rem;
        display: table-cell;
        vertical-align: middle;
    }

    /*--------------
     Loose Coupling
    ---------------*/

    .ui.header .ui.label {
        font-size: '';
        margin-left: 0.5rem;
        vertical-align: middle;
    }

    /* Positioning */
    .ui.header + p {
        margin-top: 0em;
    }


    /*******************************
                Types
    *******************************/


    /*--------------
         Page
    ---------------*/

    h1.ui.header {
        font-size: 2rem;
    }
    h2.ui.header {
        font-size: 1.71428571rem;
    }
    h3.ui.header {
        font-size: 1.28571429rem;
    }
    h4.ui.header {
        font-size: 1.07142857rem;
    }
    h5.ui.header {
        font-size: 1rem;
    }

    /* Sub Header */
    h1.ui.header .sub.header {
        font-size: 1.14285714rem;
    }
    h2.ui.header .sub.header {
        font-size: 1.14285714rem;
    }
    h3.ui.header .sub.header {
        font-size: 1rem;
    }
    h4.ui.header .sub.header {
        font-size: 1rem;
    }
    h5.ui.header .sub.header {
        font-size: 0.92857143rem;
    }

    /*--------------
     Content Heading
    ---------------*/

    .ui.huge.header {
        min-height: 1em;
        font-size: 2em;
    }
    .ui.large.header {
        font-size: 1.71428571em;
    }
    .ui.medium.header {
        font-size: 1.28571429em;
    }
    .ui.small.header {
        font-size: 1.07142857em;
    }
    .ui.tiny.header {
        font-size: 1em;
    }

    /* Sub Header */
    .ui.huge.header .sub.header {
        font-size: 1.14285714rem;
    }
    .ui.large.header .sub.header {
        font-size: 1.14285714rem;
    }
    .ui.header .sub.header {
        font-size: 1rem;
    }
    .ui.small.header .sub.header {
        font-size: 1rem;
    }
    .ui.tiny.header .sub.header {
        font-size: 0.92857143rem;
    }

    /*--------------
       Sub Heading
    ---------------*/

    .ui.sub.header {
        padding: 0em;
        margin-bottom: 0.14285714rem;
        font-weight: bold;
        font-size: 0.85714286em;
        text-transform: uppercase;
        color: '';
    }
    .ui.small.sub.header {
        font-size: 0.78571429em;
    }
    .ui.sub.header {
        font-size: 0.85714286em;
    }
    .ui.large.sub.header {
        font-size: 0.92857143em;
    }
    .ui.huge.sub.header {
        font-size: 1em;
    }

    /*-------------------
            Icon
    --------------------*/

    .ui.icon.header {
        display: inline-block;
        text-align: center;
        margin: 2rem 0em 1rem;
    }
    .ui.icon.header:after {
        content: '';
        display: block;
        height: 0px;
        clear: both;
        visibility: hidden;
    }
    .ui.icon.header:first-child {
        margin-top: 0em;
    }
    .ui.icon.header .icon {
        float: none;
        display: block;
        width: auto;
        height: auto;
        line-height: 1;
        padding: 0em;
        font-size: 3em;
        margin: 0em auto 0.5rem;
        opacity: 1;
    }
    .ui.icon.header .content {
        display: block;
        padding: 0em;
    }
    .ui.icon.header .circular.icon {
        font-size: 2em;
    }
    .ui.icon.header .square.icon {
        font-size: 2em;
    }
    .ui.block.icon.header .icon {
        margin-bottom: 0em;
    }
    .ui.icon.header.aligned {
        margin-left: auto;
        margin-right: auto;
        display: block;
    }


    /*******************************
                States
    *******************************/

    .ui.disabled.header {
        opacity: 0.45;
    }


    /*******************************
               Variations
    *******************************/


    /*-------------------
          Inverted
    --------------------*/

    .ui.inverted.header {
        color: #FFFFFF;
    }
    .ui.inverted.header .sub.header {
        color: rgba(255, 255, 255, 0.8);
    }
    .ui.inverted.attached.header {
        background: #545454 -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.05)));
        background: #545454 -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: transparent;
    }
    .ui.inverted.block.header {
        background: #545454 -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.05)));
        background: #545454 -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .ui.inverted.block.header {
        border-bottom: none;
    }

    /*-------------------
           Colors
    --------------------*/


    /*--- Red ---*/

    .ui.red.header {
        color: #DB2828 !important;
    }
    a.ui.red.header:hover {
        color: #d01919 !important;
    }
    .ui.red.dividing.header {
        border-bottom: 2px solid #DB2828;
    }

    /* Inverted */
    .ui.inverted.red.header {
        color: #FF695E !important;
    }
    a.ui.inverted.red.header:hover {
        color: #ff5144 !important;
    }

    /*--- Orange ---*/

    .ui.orange.header {
        color: #F2711C !important;
    }
    a.ui.orange.header:hover {
        color: #f26202 !important;
    }
    .ui.orange.dividing.header {
        border-bottom: 2px solid #F2711C;
    }

    /* Inverted */
    .ui.inverted.orange.header {
        color: #FF851B !important;
    }
    a.ui.inverted.orange.header:hover {
        color: #ff7701 !important;
    }

    /*--- Olive ---*/

    .ui.olive.header {
        color: #B5CC18 !important;
    }
    a.ui.olive.header:hover {
        color: #a7bd0d !important;
    }
    .ui.olive.dividing.header {
        border-bottom: 2px solid #B5CC18;
    }

    /* Inverted */
    .ui.inverted.olive.header {
        color: #D9E778 !important;
    }
    a.ui.inverted.olive.header:hover {
        color: #d8ea5c !important;
    }

    /*--- Yellow ---*/

    .ui.yellow.header {
        color: #FBBD08 !important;
    }
    a.ui.yellow.header:hover {
        color: #eaae00 !important;
    }
    .ui.yellow.dividing.header {
        border-bottom: 2px solid #FBBD08;
    }

    /* Inverted */
    .ui.inverted.yellow.header {
        color: #FFE21F !important;
    }
    a.ui.inverted.yellow.header:hover {
        color: #ffdf05 !important;
    }

    /*--- Green ---*/

    .ui.green.header {
        color: #21BA45 !important;
    }
    a.ui.green.header:hover {
        color: #16ab39 !important;
    }
    .ui.green.dividing.header {
        border-bottom: 2px solid #21BA45;
    }

    /* Inverted */
    .ui.inverted.green.header {
        color: #2ECC40 !important;
    }
    a.ui.inverted.green.header:hover {
        color: #22be34 !important;
    }

    /*--- Teal ---*/

    .ui.teal.header {
        color: #00B5AD !important;
    }
    a.ui.teal.header:hover {
        color: #009c95 !important;
    }
    .ui.teal.dividing.header {
        border-bottom: 2px solid #00B5AD;
    }

    /* Inverted */
    .ui.inverted.teal.header {
        color: #6DFFFF !important;
    }
    a.ui.inverted.teal.header:hover {
        color: #54ffff !important;
    }

    /*--- Blue ---*/

    .ui.blue.header {
        color: #2185D0 !important;
    }
    a.ui.blue.header:hover {
        color: #1678c2 !important;
    }
    .ui.blue.dividing.header {
        border-bottom: 2px solid #2185D0;
    }

    /* Inverted */
    .ui.inverted.blue.header {
        color: #54C8FF !important;
    }
    a.ui.inverted.blue.header:hover {
        color: #3ac0ff !important;
    }

    /*--- Violet ---*/

    .ui.violet.header {
        color: #6435C9 !important;
    }
    a.ui.violet.header:hover {
        color: #5829bb !important;
    }
    .ui.violet.dividing.header {
        border-bottom: 2px solid #6435C9;
    }

    /* Inverted */
    .ui.inverted.violet.header {
        color: #A291FB !important;
    }
    a.ui.inverted.violet.header:hover {
        color: #8a73ff !important;
    }

    /*--- Purple ---*/

    .ui.purple.header {
        color: #A333C8 !important;
    }
    a.ui.purple.header:hover {
        color: #9627ba !important;
    }
    .ui.purple.dividing.header {
        border-bottom: 2px solid #A333C8;
    }

    /* Inverted */
    .ui.inverted.purple.header {
        color: #DC73FF !important;
    }
    a.ui.inverted.purple.header:hover {
        color: #d65aff !important;
    }

    /*--- Pink ---*/

    .ui.pink.header {
        color: #E03997 !important;
    }
    a.ui.pink.header:hover {
        color: #e61a8d !important;
    }
    .ui.pink.dividing.header {
        border-bottom: 2px solid #E03997;
    }

    /* Inverted */
    .ui.inverted.pink.header {
        color: #FF8EDF !important;
    }
    a.ui.inverted.pink.header:hover {
        color: #ff74d8 !important;
    }

    /*--- Brown ---*/

    .ui.brown.header {
        color: #A5673F !important;
    }
    a.ui.brown.header:hover {
        color: #975b33 !important;
    }
    .ui.brown.dividing.header {
        border-bottom: 2px solid #A5673F;
    }

    /* Inverted */
    .ui.inverted.brown.header {
        color: #D67C1C !important;
    }
    a.ui.inverted.brown.header:hover {
        color: #c86f11 !important;
    }

    /*--- Grey ---*/

    .ui.grey.header {
        color: #767676 !important;
    }
    a.ui.grey.header:hover {
        color: #838383 !important;
    }
    .ui.grey.dividing.header {
        border-bottom: 2px solid #767676;
    }

    /* Inverted */
    .ui.inverted.grey.header {
        color: #DCDDDE !important;
    }
    a.ui.inverted.grey.header:hover {
        color: #cfd0d2 !important;
    }

    /*-------------------
           Aligned
    --------------------*/

    .ui.left.aligned.header {
        text-align: left;
    }
    .ui.right.aligned.header {
        text-align: right;
    }
    .ui.centered.header,
    .ui.center.aligned.header {
        text-align: center;
    }
    .ui.justified.header {
        text-align: justify;
    }
    .ui.justified.header:after {
        display: inline-block;
        content: '';
        width: 100%;
    }

    /*-------------------
           Floated
    --------------------*/

    .ui.floated.header,
    .ui[class*="left floated"].header {
        float: left;
        margin-top: 0em;
        margin-right: 0.5em;
    }
    .ui[class*="right floated"].header {
        float: right;
        margin-top: 0em;
        margin-left: 0.5em;
    }

    /*-------------------
           Fitted
    --------------------*/

    .ui.fitted.header {
        padding: 0em;
    }

    /*-------------------
          Dividing
    --------------------*/

    .ui.dividing.header {
        padding-bottom: 0.21428571rem;
        border-bottom: 1px solid rgba(34, 36, 38, 0.15);
    }
    .ui.dividing.header .sub.header {
        padding-bottom: 0.21428571rem;
    }
    .ui.dividing.header .icon {
        margin-bottom: 0em;
    }
    .ui.inverted.dividing.header {
        border-bottom-color: rgba(255, 255, 255, 0.1);
    }

    /*-------------------
            Block
    --------------------*/

    .ui.block.header {
        background: #F3F4F5;
        padding: 0.78571429rem 1rem;
        -webkit-box-shadow: none;
        box-shadow: none;
        border: 1px solid #D4D4D5;
        border-radius: 0.28571429rem;
    }
    .ui.tiny.block.header {
        font-size: 0.85714286rem;
    }
    .ui.small.block.header {
        font-size: 0.92857143rem;
    }
    .ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
        font-size: 1rem;
    }
    .ui.large.block.header {
        font-size: 1.14285714rem;
    }
    .ui.huge.block.header {
        font-size: 1.42857143rem;
    }

    /*-------------------
           Attached
    --------------------*/

    .ui.attached.header {
        background: #FFFFFF;
        padding: 0.78571429rem 1rem;
        margin-left: -1px;
        margin-right: -1px;
        -webkit-box-shadow: none;
        box-shadow: none;
        border: 1px solid #D4D4D5;
    }
    .ui.attached.block.header {
        background: #F3F4F5;
    }
    .ui.attached:not(.top):not(.bottom).header {
        margin-top: 0em;
        margin-bottom: 0em;
        border-top: none;
        border-radius: 0em;
    }
    .ui.top.attached.header {
        margin-bottom: 0em;
        border-radius: 0.28571429rem 0.28571429rem 0em 0em;
    }
    .ui.bottom.attached.header {
        margin-top: 0em;
        border-top: none;
        border-radius: 0em 0em 0.28571429rem 0.28571429rem;
    }

    /* Attached Sizes */
    .ui.tiny.attached.header {
        font-size: 0.85714286em;
    }
    .ui.small.attached.header {
        font-size: 0.92857143em;
    }
    .ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
        font-size: 1em;
    }
    .ui.large.attached.header {
        font-size: 1.14285714em;
    }
    .ui.huge.attached.header {
        font-size: 1.42857143em;
    }

    /*-------------------
            Sizing
    --------------------*/

    .ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
        font-size: 1.28571429em;
    }


    /*******************************
             Theme Overrides
    *******************************/



    /*******************************
             Site Overrides
    *******************************/

    /*!
     * # Semantic UI 2.3.2 - Table
     * http://github.com/semantic-org/semantic-ui/
     *
     *
     * Released under the MIT license
     * http://opensource.org/licenses/MIT
     *
     */


    /*******************************
                 Table
    *******************************/


    /* Prototype */
    .ui.table {
        width: 100%;
        background: #FFFFFF;
        margin: 1em 0em;
        border: 1px solid rgba(34, 36, 38, 0.15);
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 0.28571429rem;
        text-align: left;
        color: rgba(0, 0, 0, 0.87);
        border-collapse: separate;
        border-spacing: 0px;
    }
    .ui.table:first-child {
        margin-top: 0em;
    }
    .ui.table:last-child {
        margin-bottom: 0em;
    }


    /*******************************
                 Parts
    *******************************/


    /* Table Content */
    .ui.table th,
    .ui.table td {
        -webkit-transition: background 0.1s ease, color 0.1s ease;
        transition: background 0.1s ease, color 0.1s ease;
    }

    /* Headers */
    .ui.table thead {
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .ui.table thead th {
        cursor: auto;
        background: #F9FAFB;
        text-align: inherit;
        color: rgba(0, 0, 0, 0.87);
        padding: 0.92857143em 0.78571429em;
        vertical-align: inherit;
        font-style: none;
        font-weight: bold;
        text-transform: none;
        border-bottom: 1px solid rgba(34, 36, 38, 0.1);
        border-left: none;
    }
    .ui.table thead tr > th:first-child {
        border-left: none;
    }
    .ui.table thead tr:first-child > th:first-child {
        border-radius: 0.28571429rem 0em 0em 0em;
    }
    .ui.table thead tr:first-child > th:last-child {
        border-radius: 0em 0.28571429rem 0em 0em;
    }
    .ui.table thead tr:first-child > th:only-child {
        border-radius: 0.28571429rem 0.28571429rem 0em 0em;
    }

    /* Footer */
    .ui.table tfoot {
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .ui.table tfoot th {
        cursor: auto;
        border-top: 1px solid rgba(34, 36, 38, 0.15);
        background: #F9FAFB;
        text-align: inherit;
        color: rgba(0, 0, 0, 0.87);
        padding: 0.78571429em 0.78571429em;
        vertical-align: middle;
        font-style: normal;
        font-weight: normal;
        text-transform: none;
    }
    .ui.table tfoot tr > th:first-child {
        border-left: none;
    }
    .ui.table tfoot tr:first-child > th:first-child {
        border-radius: 0em 0em 0em 0.28571429rem;
    }
    .ui.table tfoot tr:first-child > th:last-child {
        border-radius: 0em 0em 0.28571429rem 0em;
    }
    .ui.table tfoot tr:first-child > th:only-child {
        border-radius: 0em 0em 0.28571429rem 0.28571429rem;
    }

    /* Table Row */
    .ui.table tr td {
        border-top: 1px solid rgba(34, 36, 38, 0.1);
    }
    .ui.table tr:first-child td {
        border-top: none;
    }

    /* Repeated tbody */
    .ui.table tbody + tbody tr:first-child td {
        border-top: 1px solid rgba(34, 36, 38, 0.1);
    }

    /* Table Cells */
    .ui.table td {
        padding: 0.78571429em 0.78571429em;
        text-align: inherit;
    }

    /* Icons */
    .ui.table > .icon {
        vertical-align: baseline;
    }
    .ui.table > .icon:only-child {
        margin: 0em;
    }

    /* Table Segment */
    .ui.table.segment {
        padding: 0em;
    }
    .ui.table.segment:after {
        display: none;
    }
    .ui.table.segment.stacked:after {
        display: block;
    }

    /* Responsive */
    @media only screen and (max-width: 767px) {
        .ui.table:not(.unstackable) {
            width: 100%;
        }
        .ui.table:not(.unstackable) tbody,
        .ui.table:not(.unstackable) tr,
        .ui.table:not(.unstackable) tr > th,
        .ui.table:not(.unstackable) tr > td {
            width: auto !important;
            display: block !important;
        }
        .ui.table:not(.unstackable) {
            padding: 0em;
        }
        .ui.table:not(.unstackable) thead {
            display: block;
        }
        .ui.table:not(.unstackable) tfoot {
            display: block;
        }
        .ui.table:not(.unstackable) tr {
            padding-top: 1em;
            padding-bottom: 1em;
            -webkit-box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
            box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
        }
        .ui.table:not(.unstackable) tr > th,
        .ui.table:not(.unstackable) tr > td {
            background: none;
            border: none !important;
            padding: 0.25em 0.75em !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }
        .ui.table:not(.unstackable) th:first-child,
        .ui.table:not(.unstackable) td:first-child {
            font-weight: bold;
        }

        /* Definition Table */
        .ui.definition.table:not(.unstackable) thead th:first-child {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }
    }


    /*******************************
                Coupling
    *******************************/


    /* UI Image */
    .ui.table th .image,
    .ui.table th .image img,
    .ui.table td .image,
    .ui.table td .image img {
        max-width: none;
    }


    /*******************************
                 Types
    *******************************/


    /*--------------
        Complex
    ---------------*/

    .ui.structured.table {
        border-collapse: collapse;
    }
    .ui.structured.table thead th {
        border-left: none;
        border-right: none;
    }
    .ui.structured.sortable.table thead th {
        border-left: 1px solid rgba(34, 36, 38, 0.15);
        border-right: 1px solid rgba(34, 36, 38, 0.15);
    }
    .ui.structured.basic.table th {
        border-left: none;
        border-right: none;
    }
    .ui.structured.celled.table tr th,
    .ui.structured.celled.table tr td {
        border-left: 1px solid rgba(34, 36, 38, 0.1);
        border-right: 1px solid rgba(34, 36, 38, 0.1);
    }

    /*--------------
       Definition
    ---------------*/

    .ui.definition.table thead:not(.full-width) th:first-child {
        pointer-events: none;
        background: transparent;
        font-weight: normal;
        color: rgba(0, 0, 0, 0.4);
        -webkit-box-shadow: -1px -1px 0px 1px #FFFFFF;
        box-shadow: -1px -1px 0px 1px #FFFFFF;
    }
    .ui.definition.table tfoot:not(.full-width) th:first-child {
        pointer-events: none;
        background: transparent;
        font-weight: rgba(0, 0, 0, 0.4);
        color: normal;
        -webkit-box-shadow: 1px 1px 0px 1px #FFFFFF;
        box-shadow: 1px 1px 0px 1px #FFFFFF;
    }

    /* Remove Border */
    .ui.celled.definition.table thead:not(.full-width) th:first-child {
        -webkit-box-shadow: 0px -1px 0px 1px #FFFFFF;
        box-shadow: 0px -1px 0px 1px #FFFFFF;
    }
    .ui.celled.definition.table tfoot:not(.full-width) th:first-child {
        -webkit-box-shadow: 0px 1px 0px 1px #FFFFFF;
        box-shadow: 0px 1px 0px 1px #FFFFFF;
    }

    /* Highlight Defining Column */
    .ui.definition.table tr td:first-child:not(.ignored),
    .ui.definition.table tr td.definition {
        background: rgba(0, 0, 0, 0.03);
        font-weight: bold;
        color: rgba(0, 0, 0, 0.95);
        text-transform: '';
        -webkit-box-shadow: '';
        box-shadow: '';
        text-align: '';
        font-size: 1em;
        padding-left: '';
        padding-right: '';
    }

    /* Fix 2nd Column */
    .ui.definition.table thead:not(.full-width) th:nth-child(2) {
        border-left: 1px solid rgba(34, 36, 38, 0.15);
    }
    .ui.definition.table tfoot:not(.full-width) th:nth-child(2) {
        border-left: 1px solid rgba(34, 36, 38, 0.15);
    }
    .ui.definition.table td:nth-child(2) {
        border-left: 1px solid rgba(34, 36, 38, 0.15);
    }


    /*******************************
                 States
    *******************************/


    /*--------------
        Positive
    ---------------*/

    .ui.table tr.positive,
    .ui.table td.positive {
        -webkit-box-shadow: 0px 0px 0px #A3C293 inset;
        box-shadow: 0px 0px 0px #A3C293 inset;
    }
    .ui.table tr.positive,
    .ui.table td.positive {
        background: #FCFFF5 !important;
        color: #2C662D !important;
    }

    /*--------------
         Negative
    ---------------*/

    .ui.table tr.negative,
    .ui.table td.negative {
        -webkit-box-shadow: 0px 0px 0px #E0B4B4 inset;
        box-shadow: 0px 0px 0px #E0B4B4 inset;
    }
    .ui.table tr.negative,
    .ui.table td.negative {
        background: #FFF6F6 !important;
        color: #9F3A38 !important;
    }

    /*--------------
          Error
    ---------------*/

    .ui.table tr.error,
    .ui.table td.error {
        -webkit-box-shadow: 0px 0px 0px #E0B4B4 inset;
        box-shadow: 0px 0px 0px #E0B4B4 inset;
    }
    .ui.table tr.error,
    .ui.table td.error {
        background: #FFF6F6 !important;
        color: #9F3A38 !important;
    }

    /*--------------
         Warning
    ---------------*/

    .ui.table tr.warning,
    .ui.table td.warning {
        -webkit-box-shadow: 0px 0px 0px #C9BA9B inset;
        box-shadow: 0px 0px 0px #C9BA9B inset;
    }
    .ui.table tr.warning,
    .ui.table td.warning {
        background: #FFFAF3 !important;
        color: #573A08 !important;
    }

    /*--------------
         Active
    ---------------*/

    .ui.table tr.active,
    .ui.table td.active {
        -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.87) inset;
        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.87) inset;
    }
    .ui.table tr.active,
    .ui.table td.active {
        background: #E0E0E0 !important;
        color: rgba(0, 0, 0, 0.87) !important;
    }

    /*--------------
         Disabled
    ---------------*/

    .ui.table tr.disabled td,
    .ui.table tr td.disabled,
    .ui.table tr.disabled:hover,
    .ui.table tr:hover td.disabled {
        pointer-events: none;
        color: rgba(40, 40, 40, 0.3);
    }


    /*******************************
              Variations
    *******************************/


    /*--------------
        Stackable
    ---------------*/

    @media only screen and (max-width: 991px) {
        .ui[class*="tablet stackable"].table,
        .ui[class*="tablet stackable"].table tbody,
        .ui[class*="tablet stackable"].table tr,
        .ui[class*="tablet stackable"].table tr > th,
        .ui[class*="tablet stackable"].table tr > td {
            width: 100% !important;
            display: block !important;
        }
        .ui[class*="tablet stackable"].table {
            padding: 0em;
        }
        .ui[class*="tablet stackable"].table thead {
            display: block;
        }
        .ui[class*="tablet stackable"].table tfoot {
            display: block;
        }
        .ui[class*="tablet stackable"].table tr {
            padding-top: 1em;
            padding-bottom: 1em;
            -webkit-box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
            box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
        }
        .ui[class*="tablet stackable"].table tr > th,
        .ui[class*="tablet stackable"].table tr > td {
            background: none;
            border: none !important;
            padding: 0.25em 0.75em;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        /* Definition Table */
        .ui.definition[class*="tablet stackable"].table thead th:first-child {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }
    }

    /*--------------
     Text Alignment
    ---------------*/

    .ui.table[class*="left aligned"],
    .ui.table [class*="left aligned"] {
        text-align: left;
    }
    .ui.table[class*="center aligned"],
    .ui.table [class*="center aligned"] {
        text-align: center;
    }
    .ui.table[class*="right aligned"],
    .ui.table [class*="right aligned"] {
        text-align: right;
    }

    /*------------------
     Vertical Alignment
    ------------------*/

    .ui.table[class*="top aligned"],
    .ui.table [class*="top aligned"] {
        vertical-align: top;
    }
    .ui.table[class*="middle aligned"],
    .ui.table [class*="middle aligned"] {
        vertical-align: middle;
    }
    .ui.table[class*="bottom aligned"],
    .ui.table [class*="bottom aligned"] {
        vertical-align: bottom;
    }

    /*--------------
        Collapsing
    ---------------*/

    .ui.table th.collapsing,
    .ui.table td.collapsing {
        width: 1px;
        white-space: nowrap;
    }

    /*--------------
         Fixed
    ---------------*/

    .ui.fixed.table {
        table-layout: fixed;
    }
    .ui.fixed.table th,
    .ui.fixed.table td {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /*--------------
       Selectable
    ---------------*/

    .ui.selectable.table tbody tr:hover,
    .ui.table tbody tr td.selectable:hover {
        background: rgba(0, 0, 0, 0.05) !important;
        color: rgba(0, 0, 0, 0.95) !important;
    }
    .ui.selectable.inverted.table tbody tr:hover,
    .ui.inverted.table tbody tr td.selectable:hover {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #ffffff !important;
    }

    /* Selectable Cell Link */
    .ui.table tbody tr td.selectable {
        padding: 0em;
    }
    .ui.table tbody tr td.selectable > a:not(.ui) {
        display: block;
        color: inherit;
        padding: 0.78571429em 0.78571429em;
    }

    /* Other States */
    .ui.selectable.table tr.error:hover,
    .ui.table tr td.selectable.error:hover,
    .ui.selectable.table tr:hover td.error {
        background: #ffe7e7 !important;
        color: #943634 !important;
    }
    .ui.selectable.table tr.warning:hover,
    .ui.table tr td.selectable.warning:hover,
    .ui.selectable.table tr:hover td.warning {
        background: #fff4e4 !important;
        color: #493107 !important;
    }
    .ui.selectable.table tr.active:hover,
    .ui.table tr td.selectable.active:hover,
    .ui.selectable.table tr:hover td.active {
        background: #E0E0E0 !important;
        color: rgba(0, 0, 0, 0.87) !important;
    }
    .ui.selectable.table tr.positive:hover,
    .ui.table tr td.selectable.positive:hover,
    .ui.selectable.table tr:hover td.positive {
        background: #f7ffe6 !important;
        color: #275b28 !important;
    }
    .ui.selectable.table tr.negative:hover,
    .ui.table tr td.selectable.negative:hover,
    .ui.selectable.table tr:hover td.negative {
        background: #ffe7e7 !important;
        color: #943634 !important;
    }

    /*-------------------
          Attached
    --------------------*/


    /* Middle */
    .ui.attached.table {
        top: 0px;
        bottom: 0px;
        border-radius: 0px;
        margin: 0em -1px;
        width: calc(100% +  2px );
        max-width: calc(100% +  2px );
        -webkit-box-shadow: none;
        box-shadow: none;
        border: 1px solid #D4D4D5;
    }
    .ui.attached + .ui.attached.table:not(.top) {
        border-top: none;
    }

    /* Top */
    .ui[class*="top attached"].table {
        bottom: 0px;
        margin-bottom: 0em;
        top: 0px;
        margin-top: 1em;
        border-radius: 0.28571429rem 0.28571429rem 0em 0em;
    }
    .ui.table[class*="top attached"]:first-child {
        margin-top: 0em;
    }

    /* Bottom */
    .ui[class*="bottom attached"].table {
        bottom: 0px;
        margin-top: 0em;
        top: 0px;
        margin-bottom: 1em;
        -webkit-box-shadow: none, none;
        box-shadow: none, none;
        border-radius: 0em 0em 0.28571429rem 0.28571429rem;
    }
    .ui[class*="bottom attached"].table:last-child {
        margin-bottom: 0em;
    }

    /*--------------
         Striped
    ---------------*/


    /* Table Striping */
    .ui.striped.table > tr:nth-child(2n),
    .ui.striped.table tbody tr:nth-child(2n) {
        background-color: rgba(0, 0, 50, 0.02);
    }

    /* Stripes */
    .ui.inverted.striped.table > tr:nth-child(2n),
    .ui.inverted.striped.table tbody tr:nth-child(2n) {
        background-color: rgba(255, 255, 255, 0.05);
    }

    /* Allow striped active hover */
    .ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {
        background: #EFEFEF !important;
        color: rgba(0, 0, 0, 0.95) !important;
    }

    /*--------------
       Single Line
    ---------------*/

    .ui.table[class*="single line"],
    .ui.table [class*="single line"] {
        white-space: nowrap;
    }
    .ui.table[class*="single line"],
    .ui.table [class*="single line"] {
        white-space: nowrap;
    }

    /*-------------------
           Colors
    --------------------*/


    /* Red */
    .ui.red.table {
        border-top: 0.2em solid #DB2828;
    }
    .ui.inverted.red.table {
        background-color: #DB2828 !important;
        color: #FFFFFF !important;
    }

    /* Orange */
    .ui.orange.table {
        border-top: 0.2em solid #F2711C;
    }
    .ui.inverted.orange.table {
        background-color: #F2711C !important;
        color: #FFFFFF !important;
    }

    /* Yellow */
    .ui.yellow.table {
        border-top: 0.2em solid #FBBD08;
    }
    .ui.inverted.yellow.table {
        background-color: #FBBD08 !important;
        color: #FFFFFF !important;
    }

    /* Olive */
    .ui.olive.table {
        border-top: 0.2em solid #B5CC18;
    }
    .ui.inverted.olive.table {
        background-color: #B5CC18 !important;
        color: #FFFFFF !important;
    }

    /* Green */
    .ui.green.table {
        border-top: 0.2em solid #21BA45;
    }
    .ui.inverted.green.table {
        background-color: #21BA45 !important;
        color: #FFFFFF !important;
    }

    /* Teal */
    .ui.teal.table {
        border-top: 0.2em solid #00B5AD;
    }
    .ui.inverted.teal.table {
        background-color: #00B5AD !important;
        color: #FFFFFF !important;
    }

    /* Blue */
    .ui.blue.table {
        border-top: 0.2em solid #2185D0;
    }
    .ui.inverted.blue.table {
        background-color: #2185D0 !important;
        color: #FFFFFF !important;
    }

    /* Violet */
    .ui.violet.table {
        border-top: 0.2em solid #6435C9;
    }
    .ui.inverted.violet.table {
        background-color: #6435C9 !important;
        color: #FFFFFF !important;
    }

    /* Purple */
    .ui.purple.table {
        border-top: 0.2em solid #A333C8;
    }
    .ui.inverted.purple.table {
        background-color: #A333C8 !important;
        color: #FFFFFF !important;
    }

    /* Pink */
    .ui.pink.table {
        border-top: 0.2em solid #E03997;
    }
    .ui.inverted.pink.table {
        background-color: #E03997 !important;
        color: #FFFFFF !important;
    }

    /* Brown */
    .ui.brown.table {
        border-top: 0.2em solid #A5673F;
    }
    .ui.inverted.brown.table {
        background-color: #A5673F !important;
        color: #FFFFFF !important;
    }

    /* Grey */
    .ui.grey.table {
        border-top: 0.2em solid #767676;
    }
    .ui.inverted.grey.table {
        background-color: #767676 !important;
        color: #FFFFFF !important;
    }

    /* Black */
    .ui.black.table {
        border-top: 0.2em solid #1B1C1D;
    }
    .ui.inverted.black.table {
        background-color: #1B1C1D !important;
        color: #FFFFFF !important;
    }

    /*--------------
      Column Count
    ---------------*/


    /* Grid Based */
    .ui.one.column.table td {
        width: 100%;
    }
    .ui.two.column.table td {
        width: 50%;
    }
    .ui.three.column.table td {
        width: 33.33333333%;
    }
    .ui.four.column.table td {
        width: 25%;
    }
    .ui.five.column.table td {
        width: 20%;
    }
    .ui.six.column.table td {
        width: 16.66666667%;
    }
    .ui.seven.column.table td {
        width: 14.28571429%;
    }
    .ui.eight.column.table td {
        width: 12.5%;
    }
    .ui.nine.column.table td {
        width: 11.11111111%;
    }
    .ui.ten.column.table td {
        width: 10%;
    }
    .ui.eleven.column.table td {
        width: 9.09090909%;
    }
    .ui.twelve.column.table td {
        width: 8.33333333%;
    }
    .ui.thirteen.column.table td {
        width: 7.69230769%;
    }
    .ui.fourteen.column.table td {
        width: 7.14285714%;
    }
    .ui.fifteen.column.table td {
        width: 6.66666667%;
    }
    .ui.sixteen.column.table td {
        width: 6.25%;
    }

    /* Column Width */
    .ui.table th.one.wide,
    .ui.table td.one.wide {
        width: 6.25%;
    }
    .ui.table th.two.wide,
    .ui.table td.two.wide {
        width: 12.5%;
    }
    .ui.table th.three.wide,
    .ui.table td.three.wide {
        width: 18.75%;
    }
    .ui.table th.four.wide,
    .ui.table td.four.wide {
        width: 25%;
    }
    .ui.table th.five.wide,
    .ui.table td.five.wide {
        width: 31.25%;
    }
    .ui.table th.six.wide,
    .ui.table td.six.wide {
        width: 37.5%;
    }
    .ui.table th.seven.wide,
    .ui.table td.seven.wide {
        width: 43.75%;
    }
    .ui.table th.eight.wide,
    .ui.table td.eight.wide {
        width: 50%;
    }
    .ui.table th.nine.wide,
    .ui.table td.nine.wide {
        width: 56.25%;
    }
    .ui.table th.ten.wide,
    .ui.table td.ten.wide {
        width: 62.5%;
    }
    .ui.table th.eleven.wide,
    .ui.table td.eleven.wide {
        width: 68.75%;
    }
    .ui.table th.twelve.wide,
    .ui.table td.twelve.wide {
        width: 75%;
    }
    .ui.table th.thirteen.wide,
    .ui.table td.thirteen.wide {
        width: 81.25%;
    }
    .ui.table th.fourteen.wide,
    .ui.table td.fourteen.wide {
        width: 87.5%;
    }
    .ui.table th.fifteen.wide,
    .ui.table td.fifteen.wide {
        width: 93.75%;
    }
    .ui.table th.sixteen.wide,
    .ui.table td.sixteen.wide {
        width: 100%;
    }

    /*--------------
        Sortable
    ---------------*/

    .ui.sortable.table thead th {
        cursor: pointer;
        white-space: nowrap;
        border-left: 1px solid rgba(34, 36, 38, 0.15);
        color: rgba(0, 0, 0, 0.87);
    }
    .ui.sortable.table thead th:first-child {
        border-left: none;
    }
    .ui.sortable.table thead th.sorted,
    .ui.sortable.table thead th.sorted:hover {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .ui.sortable.table thead th:after {
        display: none;
        font-style: normal;
        font-weight: normal;
        text-decoration: inherit;
        content: '';
        height: 1em;
        width: auto;
        opacity: 0.8;
        margin: 0em 0em 0em 0.5em;
        font-family: 'Icons';
    }
    .ui.sortable.table thead th.ascending:after {
        content: '\f0d8';
    }
    .ui.sortable.table thead th.descending:after {
        content: '\f0d7';
    }

    /* Hover */
    .ui.sortable.table th.disabled:hover {
        cursor: auto;
        color: rgba(40, 40, 40, 0.3);
    }
    .ui.sortable.table thead th:hover {
        background: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.8);
    }

    /* Sorted */
    .ui.sortable.table thead th.sorted {
        background: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.95);
    }
    .ui.sortable.table thead th.sorted:after {
        display: inline-block;
    }

    /* Sorted Hover */
    .ui.sortable.table thead th.sorted:hover {
        background: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.95);
    }

    /* Inverted */
    .ui.inverted.sortable.table thead th.sorted {
        background: rgba(255, 255, 255, 0.15) -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.05)));
        background: rgba(255, 255, 255, 0.15) -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        background: rgba(255, 255, 255, 0.15) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        color: #ffffff;
    }
    .ui.inverted.sortable.table thead th:hover {
        background: rgba(255, 255, 255, 0.08) -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.05)));
        background: rgba(255, 255, 255, 0.08) -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        background: rgba(255, 255, 255, 0.08) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
        color: #ffffff;
    }
    .ui.inverted.sortable.table thead th {
        border-left-color: transparent;
        border-right-color: transparent;
    }

    /*--------------
        Inverted
    ---------------*/


    /* Text Color */
    .ui.inverted.table {
        background: #333333;
        color: rgba(255, 255, 255, 0.9);
        border: none;
    }
    .ui.inverted.table th {
        background-color: rgba(0, 0, 0, 0.15);
        border-color: rgba(255, 255, 255, 0.1) !important;
        color: rgba(255, 255, 255, 0.9) !important;
    }
    .ui.inverted.table tr td {
        border-color: rgba(255, 255, 255, 0.1) !important;
    }
    .ui.inverted.table tr.disabled td,
    .ui.inverted.table tr td.disabled,
    .ui.inverted.table tr.disabled:hover td,
    .ui.inverted.table tr:hover td.disabled {
        pointer-events: none;
        color: rgba(225, 225, 225, 0.3);
    }

    /* Definition */
    .ui.inverted.definition.table tfoot:not(.full-width) th:first-child,
    .ui.inverted.definition.table thead:not(.full-width) th:first-child {
        background: #FFFFFF;
    }
    .ui.inverted.definition.table tr td:first-child {
        background: rgba(255, 255, 255, 0.02);
        color: #ffffff;
    }

    /*--------------
       Collapsing
    ---------------*/

    .ui.collapsing.table {
        width: auto;
    }

    /*--------------
          Basic
    ---------------*/

    .ui.basic.table {
        background: transparent;
        border: 1px solid rgba(34, 36, 38, 0.15);
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .ui.basic.table thead,
    .ui.basic.table tfoot {
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .ui.basic.table th {
        background: transparent;
        border-left: none;
    }
    .ui.basic.table tbody tr {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .ui.basic.table td {
        background: transparent;
    }
    .ui.basic.striped.table tbody tr:nth-child(2n) {
        background-color: rgba(0, 0, 0, 0.05) !important;
    }

    /* Very Basic */
    .ui[class*="very basic"].table {
        border: none;
    }
    .ui[class*="very basic"].table:not(.sortable):not(.striped) th,
    .ui[class*="very basic"].table:not(.sortable):not(.striped) td {
        padding: '';
    }
    .ui[class*="very basic"].table:not(.sortable):not(.striped) th:first-child,
    .ui[class*="very basic"].table:not(.sortable):not(.striped) td:first-child {
        padding-left: 0em;
    }
    .ui[class*="very basic"].table:not(.sortable):not(.striped) th:last-child,
    .ui[class*="very basic"].table:not(.sortable):not(.striped) td:last-child {
        padding-right: 0em;
    }
    .ui[class*="very basic"].table:not(.sortable):not(.striped) thead tr:first-child th {
        padding-top: 0em;
    }

    /*--------------
         Celled
    ---------------*/

    .ui.celled.table tr th,
    .ui.celled.table tr td {
        border-left: 1px solid rgba(34, 36, 38, 0.1);
    }
    .ui.celled.table tr th:first-child,
    .ui.celled.table tr td:first-child {
        border-left: none;
    }

    /*--------------
         Padded
    ---------------*/

    .ui.padded.table th {
        padding-left: 1em;
        padding-right: 1em;
    }
    .ui.padded.table th,
    .ui.padded.table td {
        padding: 1em 1em;
    }

    /* Very */
    .ui[class*="very padded"].table th {
        padding-left: 1.5em;
        padding-right: 1.5em;
    }
    .ui[class*="very padded"].table td {
        padding: 1.5em 1.5em;
    }

    /*--------------
         Compact
    ---------------*/

    .ui.compact.table th {
        padding-left: 0.7em;
        padding-right: 0.7em;
    }
    .ui.compact.table td {
        padding: 0.5em 0.7em;
    }

    /* Very */
    .ui[class*="very compact"].table th {
        padding-left: 0.6em;
        padding-right: 0.6em;
    }
    .ui[class*="very compact"].table td {
        padding: 0.4em 0.6em;
    }

    /*--------------
          Sizes
    ---------------*/


    /* Small */
    .ui.small.table {
        font-size: 0.9em;
    }

    /* Standard */
    .ui.table {
        font-size: 1em;
    }

    /* Large */
    .ui.large.table {
        font-size: 1.1em;
    }


    /*******************************
             Site Overrides
    *******************************/

</style>



// WEBPACK FOOTER //
// src/pages/information/KardexPage.vue